import { useState } from "react";
import { FAQS } from "../../../mocks/gossip";
import { SectionHead } from "./Shared";

export default function FaqSection() {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <section id="faq" className="w-full py-10 md:py-14" aria-label="常见问题">
      <div className="container-x">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <SectionHead
              eyebrow="FAQ"
              anchor="faq"
              title="常见问题 · FAQ"
              desc="关于更新频率、栏目含义、信息来源与投稿方式，我们整理了读者最常问的几个问题。"
            />
            <div className="hidden rounded-2xl border border-background-200 bg-background-100/70 p-5 lg:block">
              <div className="flex items-start gap-3">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-accent-500 text-background-50">
                  <i className="ri-question-mark text-lg" />
                </span>
                <p className="text-sm leading-6 text-foreground-700">
                  仍有疑问？欢迎通过页脚邮箱随时联系我们，我们会在一个工作日内回复。
                </p>
              </div>
            </div>
          </div>

          <div className="space-y-3 lg:col-span-8">
            {FAQS.map((item, i) => {
              const isOpen = openIdx === i;
              return (
                <div
                  key={i}
                  className={`overflow-hidden rounded-xl border transition-colors ${
                    isOpen
                      ? "border-primary-200 bg-background-50"
                      : "border-background-200 bg-background-100/40 hover:border-primary-200"
                  }`}
                >
                  <button
                    type="button"
                    onClick={() => setOpenIdx(isOpen ? -1 : i)}
                    aria-expanded={isOpen}
                    className="flex w-full cursor-pointer items-center justify-between gap-3 px-4 py-4 text-left md:px-5"
                  >
                    <span className="flex items-center gap-3">
                      <span
                        className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-xs font-bold ${
                          isOpen ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-600"
                        }`}
                      >
                        {String(i + 1).padStart(2, "0")}
                      </span>
                      <h3 className="font-medium text-foreground-900 md:text-base">{item.q}</h3>
                    </span>
                    <i
                      className={`ri-arrow-down-s-line shrink-0 text-xl text-foreground-500 transition-transform ${
                        isOpen ? "rotate-180 text-primary-500" : ""
                      }`}
                    />
                  </button>
                  {isOpen ? (
                    <div className="px-4 pb-5 pl-[52px] md:px-5 md:pl-[62px]">
                      <p className="text-sm leading-7 text-foreground-600">{item.a}</p>
                    </div>
                  ) : null}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}